import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@app-shared/services/auth/auth.service';
import { IntercomService } from '@app-shared/services/intercom/intercom.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private authService = inject(AuthService);
  private intercomService = inject(IntercomService);

  constructor() {
    // Intercom is now booted anonymously at the START of the onboarding flow
    // (see FlowNavigatorService) so lead-nurture attributes can attach to the
    // anonymous lead before signup — a deliberate product / lead-nurture
    // decision. This effect is the post-auth half of that lifecycle: once the
    // user is authenticated (non-anonymous) we ensure Intercom is booted
    // (idempotent — a no-op if the onboarding flow already booted it), and on
    // logout we tear it down so chat history never leaks to the next user on
    // the same browser.
    effect(() => {
      if (this.authService.isAuthenticated()) {
        this.intercomService.boot();
      } else {
        this.intercomService.shutdown();
      }
    });
  }
}
